import React, {useState} from 'react';
import DataMap from '../../components/DataMap/DataMap';
import DataTable from '../../components/DataTable/DataTable';
import { Icon } from 'leaflet';
import CesiumComponent from '../../components/CesiumComponent';
import { useRadioCoverages } from '../../hooks/radioCoverage';
import Button from '@mui/material/Button';
import RadioCoverageModal from '../../components/MarkerModals/RadioCoverageModal/RadioCoverageModal';
import RadioCoveragePopup from '../../components/Popups/RadioCoveragePopup';

const dataColumns = [
    {label: "Μελέτη", key: "name"},
    {label: "Gateway", key: "gatewayName"},
    {label: "Lat", key: "lat"},
    {label: "Lon", key: "lng"},
    {label: "Φόρτωση", key: "isLoaded"}
];


const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/gatewayicon.png'),
    iconSize: [38,38]
})

const colors = [
    "red",
    "blue",
    "green",
    "orange",
    "cyan",
    "DarkOliveGreen",
    "DarkSlateBlue",
    "DarkSlateGrey",
    "IndianRed",
    "LightSkyBlue",
    "SaddleBrown",
    "Salmon",
    "Violet",
    "Teal",
    "Tan",
]

const RadioCoverageStudy = () => {
    const  [modalOpen, setModalOpen] = useState(false);
    const {radioCoverages, loadGatewayOnMap, selectedStudyPoints, page, rowsPerPage, totalCount, handleChangePage, handleChangeRowsPerPage} = useRadioCoverages();

    return (
        <>
            <div className="mb-4">
                <DataMap markers={selectedStudyPoints} customIcon={customIcon} deviceType={"radioCoverage"} markerPopup={RadioCoveragePopup}/>
            </div>

            <div className="mb-4">
                <Button
                    variant="contained"
                    sx={{ mt: 2, alignSelf: 'flex-start' }}
                    onClick={() => setModalOpen(true)}
                >
                    Προσθήκη ραδιοκάλυψης
                </Button>

                <DataTable
                    columns={dataColumns}
                    data={radioCoverages.map(gw => {
                        var indexOnMap = -1;
                        if(selectedStudyPoints.find(ssp =>ssp.id === gw.id)){
                            indexOnMap = selectedStudyPoints.indexOf(selectedStudyPoints.find(ssp =>ssp.id === gw.id));
                        }
                        return {...gw, isLoaded: indexOnMap >= 0 ? <span style={{color: colors[indexOnMap % colors.length]}}>Ναι</span> : "Όχι"}
                    })}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalCount={totalCount}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    onRowClick={loadGatewayOnMap}
                />

            </div>

            <div className="mb-4">
                
            </div>
            <RadioCoverageModal open={modalOpen} customIcon={customIcon} onClose={() => setModalOpen(false)}/>

        </>
    );
};


export default RadioCoverageStudy;